import type { SimChangesView } from '@cruz/shared';
import { euros, signed } from './format.ts';
import { ShareButton } from './Share.tsx';

/** Pieces to show what something changed: an event's outcome, a minigame's result. */

export const signedEuros = (n: number) => `${n > 0 ? '+' : '−'}${euros(Math.abs(n))}`;

export function Delta({
  label,
  delta,
  format = signed,
}: {
  label: string;
  delta: number;
  format?: (n: number) => string;
}) {
  const up = delta > 0;
  return (
    <li
      className={`animate-rise inline-flex items-center gap-1.5 rounded-full px-3 py-1 text-sm font-semibold ${
        up
          ? 'bg-gold/20 text-gold-700 dark:bg-gold/15 dark:text-gold-300'
          : 'bg-burgundy-300/30 text-burgundy dark:bg-burgundy/30 dark:text-burgundy-300'
      }`}
    >
      {label} <span className="tabular">{format(delta)}</span>
    </li>
  );
}

/** An achievement just unlocked, with its share button when it is worth one. */
export function AchievementCard({
  achievement: a,
}: {
  achievement: SimChangesView['achievements'][number];
}) {
  return (
    <div className="animate-rise rounded-2xl border border-gold bg-cream-200 px-5 py-4 dark:bg-gold/10">
      <p className="text-xs font-semibold tracking-[0.16em] text-gold-700 uppercase dark:text-gold-300">
        Logro conseguido
      </p>
      <p className="mt-1 font-serif text-2xl font-semibold">{a.name}</p>
      <p className="text-ink-soft dark:text-cream/80">{a.description}</p>
      {a.shareable && (
        <div className="mt-3">
          <ShareButton request={{ kind: 'achievement', ref: a.id }} />
        </div>
      )}
    </div>
  );
}
